<template>
  <footer class="footer-wrap">
    <div class="footer-title">
      Spot and dot sp z o.o.
    </div>
    <div class="footer-address">
      <a
        target="_blank"
        href="https://www.google.pl/maps/place/Bednarska+7,+00-001+Warszawa/@52.2454739,21.0175619,17z/data=!3m1!4b1!4m5!3m4!1s0x471ecc678a39d68b:0x7d67168ff1478b9d!8m2!3d52.2454739!4d21.0197559"
      >
        Bednarska 7 <br >
        00-310 Warszawa
      </a>

    </div>
    <div class="footer-contact">
      <p>
        <a
          href="tel:+48790808873"
          alt="spot and dot numer telefonu"
        >
          T: +48 790 808 873
        </a>
      </p>
      <p>
        <a
          href="mailto:czesc@spotanddot.pl"
          alt="spot and dot adres e-mail"
          @click="handleMailClick"
        >
          M: czesc@spotanddot.pl
        </a>
      </p>
    </div>
    <slot />
  </footer>
</template>

<script>
export default {
  methods: {
    handleMailClick () {
      if (window.fbq) window.fbq('track', 'Contact')
    }
  }
}
</script>

<style lang="scss" scoped>
  .footer-wrap {
    display: flex;
    flex-wrap: wrap;
    position: relative;
    margin-top: 22px;
    margin-bottom: 32px;
    font-size: 9px;
    letter-spacing: 1px;
    text-transform: uppercase;
    @include media-up(md) {
      margin-top: 36px;
      margin-bottom: 41px;
      flex-wrap: nowrap;
    }
    @include media-up(lg) {
      margin-top: 66px;
      margin-bottom: 51px;
      @include font-style-regular-smaller;
      letter-spacing: 0;
    }
    a {
      @include reset-link;
    }
    p {
      margin: 0;
    }
  }
  .footer-title {
    @include grid-column((xs: 12, md: 3));
    padding: 0!important;
    font-family: $font-default-bold;
  }
  .footer-address {
    @include grid-column((md: 3));
    @include media-down(md) {
      padding-right: 0;
      padding-left: 0;
      margin-top: 14px;
      margin-bottom: 14px;
      margin-right: 35px;
    }
    @include media-down(sm) {
      margin-right: 20px;
    }
  }
  .footer-contact {
    @include grid-column((md: 5));
    @include media-down(md) {
      padding-right: 0;
      padding-left: 0;
      margin-top: 14px;
      margin-bottom: 14px;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/FooterContact.vue